/**
 * Test View Reducers
 */
import {
    TEST_VIEW_SET_IMAGE_LIST,
    TEST_VIEW_CHANGE_IMAGE_LIST,
    TEST_VIEW_SET_SHOW_IMAGE_LIST,
    TEST_VIEW_SET_SHOW_IMAGE_BROWSER,
    TEST_VIEW_SET_HANGING_TYPE,
    TEST_VIEW_SET_RESET_ID,
    TEST_VIEW_SET_CASE_DENSITY,
    TEST_VIEW_SET_CURRENT_TOOL,
    TEST_VIEW_SET_THICKNESS_TYPE,
    TEST_VIEW_SET_INITIAL_ZOOM_LEVEL,
    TEST_VIEW_FULL_IMAGEVIEWER,
    TEST_VIEW_TEST_OBJ_INFO,
    TEST_VIEW_FOCUS_VIEWER_INDEX,
    TEST_VIEW_SET_MPR_MODE_IMAGE_ID,
    TEST_VIEW_COMP_ENABLE_CINE_TOOL,
} from '../types';

const INIT_STATE = {
    attemptId: '',
    allImageList: [],
    imageList: [],
    caseDensity: -1,
    gridImageList: [[]],
    initialZoomLevel: 0,
    isShowImageBrowser: true,
    testSetHangingIdList: [],
    selectedHangingType: 'MLO-R_MLO-L_CC-R_CC-L',
    defaultImagesNumber: 1,
    volparaImageId: undefined,
    resetId: '',
    toolList: [],
    currentTool: 'Pan',
    currentThicknessType: 'NOTHICKNESS',
    fullImageViewerIndex: '-1_-1',
    modalityInfo: {},
    testSetInfo: {},
    testCaseInfo: {},
    attemptInfo: {},
    focusImageViewerIndex: null,
    mprModeImageId: null,
    enableCineTool: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TEST_VIEW_SET_IMAGE_LIST:
            return {
                ...state,
                allImageList: action.allImageList,
                imageList: action.imageList,
                gridImageList: action.gridImageList,
                isShowImageBrowser: action.isShowImageBrowser,
                initialZoomLevel: action.initialZoomLevel,
                testSetHangingIdList: action.testSetHangingIdList,
                selectedHangingType: action.selectedHangingType,
                defaultImagesNumber: action.defaultImagesNumber,
                volparaImageId: action.volparaImageId,
                caseDensity: -1,
                toolList: action.toolList,
                currentTool: action.currentTool,
                currentThicknessType: action.currentThicknessType,
                fullImageViewerIndex: '-1_-1',
                focusImageViewerIndex: null,
                mprModeImageId: null,
                enableCineTool: false,
            };
        case TEST_VIEW_CHANGE_IMAGE_LIST:
            return { ...state, imageList: action.payload};
        case TEST_VIEW_SET_SHOW_IMAGE_LIST:
            return { ...state, gridImageList: action.payload };
        case TEST_VIEW_SET_INITIAL_ZOOM_LEVEL:
            return { ...state, initialZoomLevel: action.payload.initialZoomLevel};
        case TEST_VIEW_SET_SHOW_IMAGE_BROWSER:
            return { ...state, isShowImageBrowser: action.payload };
        case TEST_VIEW_SET_HANGING_TYPE:
            return { ...state, selectedHangingType: action.payload };
        case TEST_VIEW_SET_RESET_ID:
            return {...state, resetId: action.payload};
        case TEST_VIEW_SET_CASE_DENSITY:
            return {...state, caseDensity: action.payload};
        case TEST_VIEW_SET_CURRENT_TOOL:
            return {...state, currentTool: action.payload}
        case TEST_VIEW_SET_THICKNESS_TYPE:
            return {...state, currentThicknessType: action.payload}
        case TEST_VIEW_FULL_IMAGEVIEWER:
            return {...state, fullImageViewerIndex: action.payload}
        case TEST_VIEW_TEST_OBJ_INFO:
            return {...state, modalityInfo: action.payload.modalityInfo, testCaseInfo: action.payload.testCaseInfo, attemptInfo: action.payload.attemptInfo, testSetInfo: action.payload.testSetInfo}
        case TEST_VIEW_FOCUS_VIEWER_INDEX:
            return {...state, focusImageViewerIndex: action.payload}
        case TEST_VIEW_SET_MPR_MODE_IMAGE_ID:
            return {...state, mprModeImageId: action.payload}
        case TEST_VIEW_COMP_ENABLE_CINE_TOOL:
            return {...state, enableCineTool: action.payload}
        default:
            return {...state}
    }
}